import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import OurWorkPage from './pages/OurWorkPage';
import FAQPage from './pages/FAQPage';
import BookingPage from './pages/BookingPage';
import ThankYouPage from './pages/ThankYouPage';
import { Box } from '@mui/material';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ElfsightWidget } from 'react-elfsight-widget';
import styled from 'styled-components';
import AboutUsPage from './pages/AboutUsPage';
import StructuredData from './components/StructuredData';
import CssBaseline from '@mui/material/CssBaseline';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import ThemeToggle from './components/ThemeToggle';
import { useTheme } from './context/ThemeContext';
import { themes } from './colors';
import { Helmet } from 'react-helmet-async';

// Add ResizeObserver error handler
const resizeObserverErrHandler = () => {
  const resizeObserverErrDiv = document.getElementById(
    'webpack-dev-server-client-overlay-div'
  );
  const resizeObserverErr = document.getElementById(
    'webpack-dev-server-client-overlay'
  );
  if (resizeObserverErr) {
    resizeObserverErr.setAttribute('style', 'display: none');
  }
  if (resizeObserverErrDiv) {
    resizeObserverErrDiv.setAttribute('style', 'display: none');
  }
};

const AppContent = () => {
  const { currentTheme } = useTheme();

  const muiTheme = createTheme({
    palette: {
      mode: currentTheme === themes.dark ? 'dark' : 'light',
      primary: {
        main: currentTheme.primary,
      },
      secondary: {
        main: currentTheme.secondary,
      },
      background: {
        default: currentTheme.background,
        paper: currentTheme.cardBackground,
      },
      text: {
        primary: currentTheme.text,
        secondary: currentTheme.lightText,
      },
      divider: currentTheme.border,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: currentTheme.background,
            color: currentTheme.text,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: currentTheme.cardBackground,
            color: currentTheme.text,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundColor: currentTheme.cardBackground,
            color: currentTheme.text,
            borderColor: currentTheme.border,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            color: currentTheme.text,
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            color: currentTheme.text,
          },
        },
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h1: {
        fontSize: '2.5rem',
        fontWeight: 600,
      },
      h2: {
        fontSize: '2rem',
        fontWeight: 600,
      },
      h3: {
        fontSize: '1.75rem',
        fontWeight: 500,
      },
    },
  });

  return (
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      <Helmet>
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-584864704"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-584864704');
          `}
        </script>
      </Helmet>
      <Router>
        <StructuredData />
        <Box sx={{ 
          minHeight: '100vh', 
          display: 'flex', 
          flexDirection: 'column',
          bgcolor: 'background.default',
          color: 'text.primary'
        }}>
          <Navbar />
          <ThemeToggle />
          <Box component="main" sx={{ flexGrow: 1 }}>
            <Routes>
              <Route path='/' exact element={<HomePage />} />
              <Route path='/services' element={<ServicesPage />} />
              <Route path='/our-work' element={<OurWorkPage />} />
              <Route path='/faq' element={<FAQPage />} />
              <Route path='/about-us' element={<AboutUsPage/>} />
              <Route path='/book-now' element={<BookingPage />} />
              <Route path='/thank-you' element={<ThankYouPage />} />
            </Routes>
          </Box>
          <Testimonials>
            <ElfsightWidget widgetId='81486adb-e3ff-41e3-a5f8-318cf612e1d0'/>
          </Testimonials>
          <Footer />
        </Box>
      </Router>
    </MuiThemeProvider>
  );
};

const Testimonials = styled.section``;

function App() {
  useEffect(() => {
    window.addEventListener('error', resizeObserverErrHandler);
    return () => {
      window.removeEventListener('error', resizeObserverErrHandler);
    };
  }, []);

  return (
    <HelmetProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
